export default {
    ModuleSwitch: {
        datapoint: {
            eventName: 'ModuleSwitch',
            customData: (fromModule: string, toModule: string): [any, any] => [
                fromModule,
                toModule,
            ],
            options: { isCore: true },
        },
    },
};
